module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABF0lEQVR4AeySwRGCMBBFITP0ATe42QIlWAIdaAVKB9pROvDIcJISqID4v+Mhg2xIlPHgxMmXJdm/L1mikh//InDzhseW/nFLu67L+76/QSZQd3ql1oiXRil1hmkHhY4c3pNkUtLCNE3S0lfzIhBVecIRz9AxYLOtZBKBVVXRuJeM0jxgDb3SugikAUZtjDky9hFgLT2uXCeQxrIsL4BeGbv0gvEzuNKSVSDdgB7SNNWMl4QNaZxsFUavF5CJWZbxew6MZxoAbGZz4qs3sCiKEW2rUcm+ubxYNU63tBGkvg9vIK0sDChPytcEsfNGPpNmf0FAegHVANUUY86FKBjI4gRRjEP1ETAUYudHoN2NTeLY0k3aaBd5AAAA//+5oKLtAAAABklEQVQDAIThiDnQJmreAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xiayibu_14@2x.png
// module id = 859
// module chunks = 1